export default __webpack_public_path__ + "static/media/interior2.85895d57.webp";